module.exports = __webpack_public_path__ + "img/tOFI-compressor_tn.53be9443.jpg";